import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'statusRcpp'
})
export class StatusRcppPipe implements PipeTransform {

  private states: { [key: string]: string } | null = null;

  constructor(private translateS: TranslateService) {
    this.states = this.translateS.instant('Miscellaneous.StatusPilars');
  }

  /**
   * Transforma el estado de un reto a un objeto con propiedades booleanas
   * @param value El valor del estado
   * @returns Un objeto con propiedades booleanas
   */
  transform(value: number): StatusRcpp {
    return {
      isNotApplicable: this.states[value] === 'NO_APLICA',
      isUnavailable: this.states[value] === 'PROXIMAMENTE',
      isAvailable: this.states[value] === 'EN_PROGRESO',
      isCompleted: this.states[value] === 'COMPLETADO',
      isExpired: this.states[value] === 'EXPIRADO',
    };
  }

}

export interface StatusRcpp {
  isNotApplicable: boolean;
  isUnavailable: boolean;
  isAvailable: boolean;
  isCompleted: boolean;
  isExpired: boolean;
}
